function sessionTimeoutLogoutFlow() {
	if (localStorage.getItem('autoLogoutHappened')) {
		const logoutAlert = document.querySelector('.js-logout-alert');

		if (logoutAlert) {
			logoutAlert.classList.remove('d-none');
		}

		localStorage.removeItem('autoLogoutHappened');
	}

	if (window.location.href.indexOf('/login') === -1 && window.od.userLoggedIn) {
		setTimeout(() => {
			localStorage.setItem('autoLogoutHappened', true);
			window.location.replace('/login');
		}, window.od.maxInactiveInterval);
	}
}

export default sessionTimeoutLogoutFlow;
